import { gql } from '@apollo/client';
import { ContentImportSummary, FrameworkImportPayload, ScenarioPackImportPayload } from 'src/types/contentImport';

export const CREATE_SCENARIO_GROUP_FROM_IMPORT = gql`
  mutation createScenarioGroupFromImport($input: ScenarioGroupImportInput!) {
    createScenarioGroupFromImport(input: $input) {
      groupId
      frameworkId
      metadataUpdated
      createdCount
      updatedCount
      unchangedCount
    }
  }
`;

export interface CreateScenarioGroupFromImportMutation {
  createScenarioGroupFromImport: ContentImportSummary;
}

export interface CreateScenarioGroupFromImportMutationVariables {
  input: ScenarioPackImportPayload;
}

export const UPSERT_SCENARIO_PACK_FEATURE = gql`
  mutation upsertScenarioPackFeature(
    $name: String!
    $general: Boolean!
    $organisations: [UxId!]!
    $workspaces: [UxId!]!
  ) {
    upsertFeature(name: $name, general: $general, organisations: $organisations, workspaces: $workspaces) {
      name
      general
      organisations
      workspaces
    }
  }
`;

interface ScenarioPackFeaturePayload {
  name: string;
  general: boolean;
  organisations: string[];
  workspaces: string[];
}

export interface UpsertScenarioPackFeatureMutation {
  upsertFeature: ScenarioPackFeaturePayload;
}

export interface UpsertScenarioPackFeatureMutationVariables {
  name: string;
  general: boolean;
  organisations: string[];
  workspaces: string[];
}

export const UPDATE_SCENARIO_GROUP_METADATA = gql`
  mutation updateScenarioGroupMetadata($scenarioGroupId: UxId!, $group: ScenarioPackGroupImportInput!) {
    updateScenarioGroupMetadata(scenarioGroupId: $scenarioGroupId, group: $group) {
      groupId
      frameworkId
      metadataUpdated
      createdCount
      updatedCount
      unchangedCount
    }
  }
`;

export interface UpdateScenarioGroupMetadataMutation {
  updateScenarioGroupMetadata: ContentImportSummary;
}

export interface UpdateScenarioGroupMetadataMutationVariables {
  scenarioGroupId: string;
  group: ScenarioPackImportPayload['group'];
}

export const IMPORT_SCENARIO_GROUP = gql`
  mutation importScenarioGroup($scenarioGroupId: UxId!, $input: ScenarioGroupImportInput!) {
    importScenarioGroup(scenarioGroupId: $scenarioGroupId, input: $input) {
      groupId
      frameworkId
      metadataUpdated
      createdCount
      updatedCount
      unchangedCount
    }
  }
`;

export interface ImportScenarioGroupMutation {
  importScenarioGroup: ContentImportSummary;
}

export interface ImportScenarioGroupMutationVariables {
  scenarioGroupId: string;
  input: ScenarioPackImportPayload;
}

export const IMPORT_FRAMEWORK = gql`
  mutation importFramework($frameworkId: UxId!, $input: FrameworkImportInput!) {
    importFramework(frameworkId: $frameworkId, input: $input) {
      groupId
      frameworkId
      metadataUpdated
      createdCount
      updatedCount
      unchangedCount
    }
  }
`;

export interface ImportFrameworkMutation {
  importFramework: ContentImportSummary;
}

export interface ImportFrameworkMutationVariables {
  frameworkId: string;
  input: FrameworkImportPayload;
}
